import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { SiteState } from '@next/core-lib/site';
import { Store, select } from '@ngrx/store';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectSalesOrderPeriods } from 'src/app/store/selectors';

import * as OverviewActions from '../../../store/actions';
import { SalesOrderPeriod } from '../../models';

@Component({
  selector: 'app-period-column-header',
  templateUrl: './period-column-header.component.html',
  styleUrls: ['./period-column-header.component.scss'],
  standalone: false,
})
export class PeriodColumnHeaderComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly datePipe = inject(DatePipe);
  readonly locale = inject(LocaleService);

  @Input() rowName: string;

  salesOrderPeriods: SalesOrderPeriod[];

  private readonly destroyed$ = new Subject<boolean>();

  ngOnInit(): void {
    this.store.pipe(select(selectSalesOrderPeriods), takeUntil(this.destroyed$)).subscribe((salesOrderPeriods) => {
      this.salesOrderPeriods = salesOrderPeriods;
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  movePeriodData() {
    if (this.salesOrderPeriods) {
      const period = this.salesOrderPeriods.find((x) => x.name === this.rowName);
      if (period) {
        this.store.dispatch(OverviewActions.openMoveProductData({ fromPeriodId: period.id }));
      }
    }
  }

  getSaleOrderPeriodClosingDate(periodName: string): string {
    if (this.salesOrderPeriods) {
      const period = this.salesOrderPeriods.find((x) => x.name === periodName);
      if (period) {
        const date = new Date(period.orderReceivedBefore);
        return this.formatDate(date);
      }
    }
    return '';
  }

  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'dd MMM yyyy');
  }
}
